import React from 'react';

// --- Helper Components ---
export const Loader = ({ text = "Loading..." }) => (
    <div className="PHAWBT-loader-container">
        <div className="PHAWBT-loader">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
        <p>{text}</p>
    </div>
);

export const DataTable = ({ data, title, onRowClick, maxHeight = '400px', highlightRowKey, highlightRowValue }) => {
    if (!data || data.length === 0) {
        return (
            <div className="PHAWBT-nodata-container">
                <h4>{title}</h4>
                <p>No data available.</p>
            </div>
        );
    }
    
    const headers = Object.keys(data[0]);
    
    return (
        <div className="PHAWBT-table-container">
            {title && <h4 className="PHAWBT-table-title">{title}</h4>}
            <div className="PHAWBT-table-wrapper" style={{ maxHeight }}>
                <table className="PHAWBT-table">
                    <thead>
                        <tr>
                            {headers.map(header => (
                                <th key={header}>{header}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((row, index) => (
                            <tr 
                                key={index} 
                                onClick={() => onRowClick && onRowClick(row)}
                                className={`${onRowClick ? 'PHAWBT-clickable-row' : ''} ${
                                    highlightRowKey && highlightRowValue && row[highlightRowKey] === highlightRowValue 
                                        ? 'PHAWBT-highlighted-row' 
                                        : ''
                                }`}
                            >
                                {headers.map(header => (
                                    <td key={header}>
                                        {typeof row[header] === 'number' 
                                            ? Number(row[header]).toFixed(4) 
                                            : String(row[header] || '')
                                        }
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export const ControlPanel = ({ children }) => (
    <div className="PHAWBT-controls">{children}</div>
);

export const ControlGroup = ({ title, children }) => (
    <div className="PHAWBT-control-group">
        <h5>{title}</h5>
        <div className="PHAWBT-control-items">{children}</div>
    </div>
);
